import { auth, db } from '../firebase'
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import firebase from 'firebase'

export const USER_SIGN_IN_SUCCES = 'USER_SIGN_IN_SUCCES'
export const USER_SIGN_IN_ERROR = 'USER_SIGN_IN_ERROR'
export const USER_SIGN_IN = 'USER_SIGN_IN'
export const USER_SIGN_OUT_SUCCESS = 'USER_SIGN_OUT_SUCCESS'
export const USER_SIGN_OUT_ERROR = 'USER_SIGN_OUT_ERROR'
export const ADMIN_SIGN_IN = 'ADMIN_SIGN_IN'
export const RESET_PASSWORD = 'RESET_PASSWORD'

firebase.auth().languageCode = 'fr'

export const userSignInSuccess = bool => {
  return {
    type: USER_SIGN_IN_SUCCES,
    user: bool
  }
}

export const userSignInError = bool => {
  return {
    type: USER_SIGN_IN_ERROR,
    hasError: bool
  }
}

export const adminSignIn = bool => {
  return {
    type: ADMIN_SIGN_IN,
    admin: bool
  }
}

export const signIn = (email, password) => {
  return dispatch => {
    ;() => dispatch(userSignInSuccess(false))
    auth.setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => {
      auth
        .signInWithEmailAndPassword(email, password)
        .then(() => {
          if (auth.currentUser) {
            dispatch(userSignInSuccess(true))
          }
        })
        .catch(function(error) {
          swal('Erreur', 'Votre email/mot de passe est invalide', 'error').then(
            () => dispatch(userSignInError(false))
          )
          var errorCode = error.code
          var errorMessage = error.message
          console.error(error)
        })
    })
  }
}

export const resetPassword = email => {
  return dispatch => {
    return auth
      .sendPasswordResetEmail(email)
      .then(function() {
        // console.log('envoyé')
        swal(
          'Envoyé',
          'Un mail vous a été envoyer pour réinitialiser votre mot de passe',
          'success'
        )
      })
      .catch(function(error) {
        swal('Erreur', 'Une erreur est survenue, veuillez réessayer', 'error')
      })
  }
}

export const signOutSuccess = () => {
  return {
    type: USER_SIGN_OUT_SUCCESS
  }
}

export const signOutError = bool => {
  return {
    type: USER_SIGN_OUT_ERROR,
    hasError: bool
  }
}

export const signOut = () => {
  return dispatch => {
    auth
      .signOut()
      .then(() => {
        dispatch(userSignInSuccess(false))
        window.location.reload()
      })
      .catch(err => {
        dispatch(signOutError(true))
        console.error(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js